import { Typography } from 'hephaestus/web';
import { householdColors, memberColors } from './memberColors';

export type MemberTagArgs = {
  sequenceNumber: number | 'HOUSEHOLD';
  name: string;
};

export const MemberTag = ({ sequenceNumber, name }: MemberTagArgs) => {
  const colors =
    sequenceNumber === 'HOUSEHOLD'
      ? householdColors
      : memberColors(sequenceNumber);

  return (
    <Typography
      variant='bodySmall'
      align='center'
      color={colors.fg}
      sx={{
        display: 'inline-block',
        fontSize: '11px',
        fontWeight: 600,
        bgcolor: colors.bg,
        lineHeight: '18px',
        height: 'unset',
        px: '5px',
        borderRadius: '2px',
      }}
    >
      {name}
    </Typography>
  );
};
